module.exports = __webpack_public_path__ + "img/课堂建设.79eb825c.svg";